import React, { Fragment, useState, useContext } from "react";
import { Redirect } from "react-router-dom";
import { UrlServicesContext } from "components/UrlServicesContext";

import { makeStyles } from "@mui/styles";
import {
  Grid,
  DialogActions,
  DialogContent,
  Alert,
  Dialog,
  TextField,
  Snackbar,
  Slide,
  Box,
} from "@mui/material";
import {
  Close,
  CheckCircle,
  ReceiptOutlined,
  SearchOutlined,
  DoNotDisturbOnOutlined,
  HighlightOffOutlined,
  //CreditCardOutlined,
  CalendarMonthOutlined,
} from "@mui/icons-material";
import Moment from "moment";
import axios from "axios";

import ViewsTrasactionsPayment from "views/dialog/ViewsTrasactionsPayment";

import loaderGif from "assets/img/loading.gif";

import {
  cardBodyStyle,
  ButtonExit,
  ButtonStyle0,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function ViewstrasactionsAdmin(props) {
  const classes = useStyles();

  const [openDetails, setOpenDetails] = React.useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [loaderSave, setLoaderSave] = useState(false);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [returnLogin, setReturnLogin] = React.useState(false);

  const [alert, setAlert] = React.useState({
    openAlert: false,
    errorAlert: "error",
    mensaje: "",
  });

  const { urlServices, UserAuth } = useContext(UrlServicesContext);

  let acceptTerms = JSON.parse(props.id.row.acceptTerms);
  let prefix = props.id.row.client.prefix;
  let product = props.id.row.productsJson[0];
  const typePayCR = product.typePay === "CR" ? true : false;
  const cardRegister =
    Array.isArray(props.id.row.client?.cardCollection) &&
    props.id.row.client?.cardCollection.length > 0;

  const [values, setValues] = useState({
    detailsCancel: "",
    date: Moment().format("DD-MM-YYYY"),
    detailsCancelDisabled: false,
    errorDetailsCancel: false,
  });

  let caracteristicas = product.prices.find(
    (data) => data.price === product.priceSelect
  );

  const handleChange = (prop, value) => {
    setValues((prevValues) => ({
      ...prevValues,
      [prop]: value,
      errorDetailsCancel: false,
    }));

    setAlert({ ...alert, openAlert: false });
  };

  const submitSave = async () => {
    setLoaderSave(true);

    try {
      if (values.detailsCancel.length === 0) {
        setValues({ ...values, errorDetailsCancel: true });
        setAlert({
          ...alert,
          openAlert: true,
          errorAlert: "error",
          mensaje: `Debe ingresar un motivo de la cancelación`,
        });

        setLoaderSave(false);
        return; // Salir si hay un error
      }

      const value = {
        status: 0,
        detailsCancel: JSON.stringify({
          details: values.detailsCancel,
          userId: UserAuth.id,
          date: values.date,
        }),
        endRecurringPayment: Moment().format("YYYY-MM-DD"),
      };

      const response = await axios.put(
        `${urlServices}clients-transaction/${props.id.id}`,
        value
      );

      if (response.status === 200) {
        handleSendCancel();
        setValues({ ...values, detailsCancelDisabled: true });
        setAlert({
          ...alert,
          openAlert: true,
          errorAlert: "success",
          mensaje: `Cancelación realizada con éxito.`,
        });
        props.callBackRefresh();
      }
    } catch (error) {
      if (error.response?.status === 401) {
        setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
        setError(true);
        setTimeout(() => {
          localStorage.clear();
          setReturnLogin(true);
        }, 4000);
      } else if (error.response?.status === 500) {
        setMensageSystem("Error en la consulta con el servidor.");
        setError(true);
      } else {
        console.error("Error en la solicitud:", error);
        setMensageSystem("Error al realizar la solicitud.");
        setError(true);
      }
    }

    setLoaderSave(false);
  };

  const handleSendCancel = async () => {
    try {
      const value = {
        clientsTransactionId: props.id.id,
        client: props.id.row.client,
      };

      const response = await axios.post(
        `${urlServices}clients-transaction/sentinel-darbaja`,
        value
      );

      if (response.status === 200) {
      }
    } catch (error) {}
  };

  const handleDetails = () => () => {
    setOpenDetails(true);
  };

  const handleCloseDetails = () => {
    setOpenDetails(false);
  };

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  // Function to close the modal
  const handleCloseModal = () => {
    setOpenModal(false); // Close the modal
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ openAlert: false });
  };

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <Dialog
        fullWidth
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        maxWidth={"xs"}
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Fragment>
            <Grid container className={classes.containerProfile}>
              <Grid item xs={12} sm={12}>
                <div className={classes.titleCardFilter}>
                  <ReceiptOutlined /> Transacción
                </div>
                <div className={classes.lineBottom}></div>
                <br></br>
              </Grid>
              <Grid item xs={12} md={12} sx={{ textAlign: "right" }}>
                <b style={{ fontSize: 12, color: "#000" }}>Creado:</b>{" "}
                <span style={{ fontWeight: 400 }}>
                  {Moment(props.id.row.createdAt).format("DD-MM-YYYY")}
                </span>
              </Grid>
              <Grid item xs={12} md={12}>
                <b style={{ fontSize: 12, color: "#000" }}>Cliente:</b>{" "}
                <span style={{ fontWeight: 400 }}>
                  {props.id.row.client.allNames}
                </span>
              </Grid>
              <Grid item xs={12} md={12}>
                <b style={{ fontSize: 12, color: "#000" }}>Documento:</b>{" "}
                <span style={{ fontWeight: 400 }}>
                  {props.id.row.client.documentId}
                </span>
              </Grid>
              <Grid item xs={12} md={12}>
                <b style={{ fontSize: 12, color: "#000" }}>Email:</b>{" "}
                <span style={{ fontWeight: 400 }}>
                  {props.id.row.client.email}
                </span>
              </Grid>
              <Grid item xs={12} md={12}>
                <b style={{ fontSize: 12 }}>Teléfono:</b>{" "}
                <span style={{ fontWeight: 400 }}>
                  +{prefix.prefix} {props.id.row.client.phone}
                </span>
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  textAlign: "center",
                  p: 0.6,
                  m: 1,
                  background: "#F6F6F6",
                }}
              >
                <b style={{ fontSize: 12 }}>PRODUCTO</b>
              </Grid>
              <Grid item xs={6} md={6} sx={{ textAlign: "center" }}>
                <span style={{ fontWeight: 400 }}>
                  {product.name} <br></br>{" "}
                  <span style={{ fontWeight: 400, fontSize: 12 }}>
                    ({caracteristicas.name})
                  </span>
                </span>
              </Grid>
              <Grid item xs={6} md={6} sx={{ textAlign: "center", pt: 1 }}>
                <span style={{ fontWeight: 500, fontSize: 14 }}>
                  {typePayCR
                    ? `TOTAL: $${product.payMonthTotal}`
                    : `TOTAL: $${product.payTotal}`}
                </span>
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  textAlign: "center",
                  p: 0.6,
                  m: 1,
                  background: "#F6F6F6",
                }}
              >
                <b style={{ fontSize: 12 }}>ESTADO</b>
              </Grid>
              <Grid item xs={6} md={6} sx={{ textAlign: "center" }}>
                <Alert
                  sx={{
                    fontSize: 10,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                  }}
                  severity={
                    props.id.row.acceptTerms ||
                    cardRegister ||
                    (props.id.row.cashPaymentTransactions &&
                      props.id.row.cashPaymentTransactions.length > 0)
                      ? "success"
                      : "error"
                  }
                  icon={false}
                >
                  TERMINOS:<br></br>{" "}
                  {props.id.row.acceptTerms || cardRegister || 
                  (props.id.row.cashPaymentTransactions &&
                    props.id.row.cashPaymentTransactions.length > 0) ? (
                    <>
                      <CheckCircle sx={{ color: "green" }} />
                      <br></br>(Aceptado:{" "}
                      {props.id.row.acceptTerms
                        ? acceptTerms.date
                        : Moment(props.id.row.createdAt).format("DD-MM-YYYY")}
                    </>
                  ) : (
                    <Close sx={{ color: "red" }} />
                  )}
                </Alert>
              </Grid>
              <Grid
                item
                xs={6}
                md={6}
                sx={{
                  textAlign: "center",
                  display:
                    props.id.row.cashPaymentTransactions &&
                    props.id.row.cashPaymentTransactions.length > 0
                      ? "none"
                      : "block",
                }}
              >
                <div
                  style={{
                    fontSize: 10,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                    marginTop: 2,
                  }}
                >
                  PAGO TARJETA:<br></br>{" "}
                  <ButtonStyle0
                    style={{ width: 140, fontSize: 12 }}
                    onClick={handleDetails()}
                    disabled={
                      props.id.row.paymentTransactions.length > 0 ? false : true
                    }
                  >
                    Ver detalle <SearchOutlined sx={{ fontSize: 20, ml: 1 }} />
                  </ButtonStyle0>
                </div>
              </Grid>
              <Grid
                item
                xs={6}
                md={6}
                sx={{
                  textAlign: "center",
                  display:
                    props.id.row.cashPaymentTransactions &&
                    props.id.row.cashPaymentTransactions.length > 0
                      ? "block"
                      : "none",
                }}
              >
                <Alert
                  sx={{
                    fontSize: 14,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                    m: "10px 0 0 10px",
                  }}
                  severity={"success"}
                  icon={false}
                >
                  PAGO AL CONTADO
                  <br></br>
                  <span style={{ fontWeight: 500, fontSize: 10 }}>
                    (Descuento:{" "}
                    {
                      props.id.row.cashPaymentTransactions[0]
                        ?.discountPercentage
                    }
                    %)
                  </span>
                </Alert>
              </Grid>

              {typePayCR && (
                <>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    sx={{
                      textAlign: "center",
                      p: 0.6,
                      m: 1,
                      background: "#F6F6F6",
                    }}
                  >
                    <b style={{ fontSize: 12, color: "#000" }}>
                      COBRO RECURRENTE
                    </b>
                  </Grid>
                  <Grid item xs={12} md={12} sx={{ textAlign: "center" }}>
                    <Grid container>
                      {/*<Grid item xs={6} md={6}>
                        <span style={{ fontWeight: 400 }}>
                          <CreditCardOutlined
                            sx={{ verticalAlign: "middle" }}
                          />{" "}
                          {product.periodo > 0
                            ? product.periodo + " MESES"
                            : product.periodo + " MES"}
                          <br></br>
                          <div style={{ fontSize: 14 }}>
                            Finaliza:{" "}
                            {Moment(props.id.row.endRecurringPayment).format(
                              "DD-MM-YYYY"
                            )}
                          </div>
                        </span>
                      </Grid>*/}
                      <Grid item xs={12} md={12}>
                        <span style={{ fontWeight: "bold", fontSize: 14 }}>
                          {Moment(props.id.row.endRecurringPayment).format(
                            "DD-MM-YYYY"
                          ) === Moment().format("DD-MM-YYYY") ? (
                            <Box sx={{ mt: 2, color: "green" }}>
                              PAGO FINALIZADO
                            </Box>
                          ) : (
                            <>
                              Próximo cobro{" "}
                              <CalendarMonthOutlined
                                sx={{ verticalAlign: "middle", fontSize: 16 }}
                              />
                              <br></br>
                              {Moment(props.id.row.nextRecurringPayment).format(
                                "DD-MM-YYYY"
                              )}
                            </>
                          )}
                        </span>
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              )}
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  textAlign: "center",
                  p: 0.6,
                  m: 1,
                  background: "#F6F6F6",
                }}
              >
                <b style={{ fontSize: 12, color: "#000" }}>GESTOR</b>
              </Grid>
              <Grid item xs={12} md={12} sx={{ textAlign: "center" }}>
                <span style={{ fontWeight: 400 }}>
                  {props.id.row.user.allNames}
                </span>
                <br></br>
                <b style={{ fontSize: 10 }}>
                  ({props.id.row.user.profile.name})
                </b>
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  textAlign: "center",
                  display: values.detailsCancelDisabled
                    ? "none"
                    : parseInt(UserAuth.profile_id) === 1
                    ? "none"
                    : props.id.row.status === 0
                    ? "none"
                    : "block",
                }}
              >
                <ButtonStyle0
                  style={{
                    width: 200,
                    fontSize: 12,
                    background: "red",
                    marginTop: 15,
                  }}
                  onClick={() => setOpenModal(true)}
                >
                  Cancelar transacción{" "}
                  <DoNotDisturbOnOutlined sx={{ fontSize: 20, ml: 1 }} />
                </ButtonStyle0>
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  display:
                    props.id.row.status === 0 || values.detailsCancelDisabled
                      ? "block"
                      : "none",
                }}
              >
                <Alert
                  icon={false}
                  severity="error"
                  sx={{ fontSize: 14, m: 1 }}
                >
                  <b>
                    <HighlightOffOutlined sx={{ verticalAlign: "middle" }} />{" "}
                    Transacción cancelada
                  </b>
                  <br></br>
                  <br></br>
                  <b>Descripción:</b>{" "}
                  {values.detailsCancelDisabled
                    ? values.detailsCancel
                    : props.id.row.detailsCancel
                    ? props.id.row.detailsCancel.details
                    : ""}
                  <br></br>
                  <b>Fecha:</b>{" "}
                  {values.detailsCancelDisabled
                    ? values.date
                    : props.id.row.detailsCancel
                    ? props.id.row.detailsCancel.date
                    : "00-00-0000"}
                </Alert>
              </Grid>
            </Grid>
            {openDetails && (
              <ViewsTrasactionsPayment
                open={openDetails}
                exit={handleCloseDetails}
                id={props.id.row}
              />
            )}
          </Fragment>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDialog(true)}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
      {/* Modal */}
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent className={classes.styleDialogContent}>
          <Grid container spacing={1} className={classes.containerProfile}>
            <Grid item xs={12} sm={12}>
              {error && <Alert severity="error">{mensageSystem}</Alert>}

              <div className={classes.titleCardFilter}>
                Cancelar transacción
              </div>
              <div className={classes.lineBottom}></div>
              <br></br>
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                id="outlined-multiline-flexible"
                label="Descripción de la cancelación"
                value={values.detailsCancel}
                error={values.errorDetailsCancel}
                onChange={(event) => {
                  handleChange("detailsCancel", event.target.value);
                }}
                placeholder="Ingresar..."
                fullWidth
                multiline
                rows={4}
                helperText="Ingresar el motivo de la cancelación del registro."
                disabled={values.detailsCancelDisabled}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <center>
                <ButtonStyle0
                  style={{
                    background:
                      loaderSave || values.detailsCancelDisabled
                        ? "#ccc"
                        : "red",
                    marginTop: 5,
                    color: "#fff",
                  }}
                  onClick={submitSave}
                  disabled={loaderSave || values.detailsCancelDisabled}
                >
                  {loaderSave ? (
                    <>
                      <img
                        alt="loaderGif"
                        src={loaderGif}
                        style={{ width: 35, marginRight: 8 }} // Ajusta el tamaño y el margen
                      />
                      Registrando...
                    </>
                  ) : (
                    "Cancelar"
                  )}
                </ButtonStyle0>
              </center>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseModal}>Cerrar</ButtonExit>
        </DialogActions>
        {alert.openAlert && (
          <Snackbar
            open={true}
            autoHideDuration={20000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleCloseAlert}
          >
            <Slide direction="up" in={true} mountOnEnter unmountOnExit>
              <Alert
                onClose={handleCloseAlert}
                severity={alert.errorAlert === "error" ? "error" : "success"}
                elevation={6}
                variant="filled"
              >
                {alert.mensaje}
              </Alert>
            </Slide>
          </Snackbar>
        )}
      </Dialog>
    </Fragment>
  );
}
